import {Component, Input, OnInit} from '@angular/core';
import {BaseModal} from '@ui-app/modals/base-modal';
import * as EmployeeModels from '@employee-models/index';
import {IRequestListGridRequest} from '@employee-models/data.models';
import * as SharedModels from '@ui-app/models';

enum SortingColumnNames {
    BadgeRequestReasonName = 1,
    RequestedDateStr = 2,
    PhotoRequestStatusName = 3,
    BadgeRequestStatusName = 4
}

interface SortingOptionModel {
    reasonType: number;
    sortName: string;
    sortingOrder: string;
}

@Component({
  selector: 'employee-mobile-request-list-sort-modal',
  templateUrl: './mobile-request-list-sort-modal.component.html',
  styleUrls: ['./mobile-request-list-sort-modal.component.less']
})

export class MobileRequestsListSortModalComponent extends BaseModal implements OnInit {

    @Input() popupTitle = 'Sorting';
    @Input() showButtonNo  = true;
    @Input() showButtonYes = true;
    @Input() buttonsTitle  = {
        dismiss: 'Cancel',
        confirm: 'Apply'
    };
    @Input() gridRequest: IRequestListGridRequest;
    @Input() gridData: EmployeeModels.DM.ITableWithFilterModelGeneric<EmployeeModels.DM.IRequestResponse>;

    readonly sortingColumnNames = SortingColumnNames;
    readonly sortOrder = SharedModels.CE.SortOrder;
    readonly defaultSortingColumn = `${SortingColumnNames[2]} ${SharedModels.CE.SortOrder.DESC}`;
    selectedSortingColumn: string = null;
    sortingOptions: Array<SortingOptionModel> = [];

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.selectedSortingColumn = this.gridRequest.sortColumn ? this.gridRequest.sortColumn : this.defaultSortingColumn;
        this.sortingOptions = this.getSortingOptionList(this.gridData.tableDescription.columnsConfig);
    }

    applySorting(): void {
        this.gridRequest.sortColumn = this.selectedSortingColumn;
        this.action(this.gridRequest);
    }

    toggleColumnSort(sortingColumnName: string): void {
        this.selectedSortingColumn = sortingColumnName;
    }

    getSortingOptionList(columnsConfig: EmployeeModels.DM.ITableMappingDto[]): Array<SortingOptionModel>  {
        const sortingOptionsList: Array<SortingOptionModel> = [];
        columnsConfig.forEach(columnn => {
            if (Object.keys(SortingColumnNames).some((v) => v === columnn.sortName)) {

                const ascSortingOption: SortingOptionModel = {
                    reasonType: SortingColumnNames[columnn.sortName],
                    sortName: `${columnn.sortName} ${SharedModels.CE.SortOrder.ASC}`,
                    sortingOrder: SharedModels.CE.SortOrder.ASC
                };
                const descSortingOption: SortingOptionModel = {
                    reasonType: SortingColumnNames[columnn.sortName],
                    sortName: `${columnn.sortName} ${SharedModels.CE.SortOrder.DESC}`,
                    sortingOrder: SharedModels.CE.SortOrder.DESC
                };
                sortingOptionsList.push(ascSortingOption, descSortingOption);
            }
        });
        sortingOptionsList.sort((a, b) => a.reasonType - b.reasonType);
        return sortingOptionsList;
    }

}
